import classNames from "classnames";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { PlaceholderImageSmall } from "../../pages/ProfilePage/ProfileImageUpdate";
import { UserProfileLinkFragment } from "../../types/User";
import "./PublicUserProfileLink.scss";

export function PublicUserProfileLink({
  profile,
  size = "md",
  linkToProfile = true,
}: {
  profile: UserProfileLinkFragment;
  size?: "sm" | "md";
  linkToProfile?: boolean;
}) {
  const navigate = useNavigate();

  const navigateToProfile = useCallback(() => {
    if (linkToProfile) {
      navigate(`/player/${profile.username}`);
    }
  }, [navigate, profile, linkToProfile]);

  const className = classNames(`public-user-profile-link ${size}`, {
    clickable: linkToProfile,
  });
  return (
    <div className={className} onClick={navigateToProfile}>
      <img src={profile.photoURL || PlaceholderImageSmall} alt="Vibe Author" />
      <div className="public-user-profile-link-name">{profile.username}</div>
    </div>
  );
}
